import { render, staticRenderFns } from "./ClaimDocs.vue?vue&type=template&id=40449bf7&scoped=true"
import script from "./ClaimDocs.vue?vue&type=script&lang=js"
export * from "./ClaimDocs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40449bf7",
  null
  
)

export default component.exports